import React, { useState, useEffect } from "react";
import serviceProvider from '../../services/axios'
import { QuickStart } from "../quickstart/quickstart-ctrl";
import { CpgstudyView } from "./cpgstudy-view";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import { Helmet } from "react-helmet";
import "./cpgstudy.scss";
export const CpgstudyController = (props) => {
	const [results, setResults] = useState([]);
	const [tourComplete, setTourComplete] = useState("");
	const user = JSON.parse(localStorage.getItem("userData"));
	const usid = user ? user.uid : 0;
	useEffect(() => {
		props.handleExpandFal();
		const search = async () => {
			const apiUrl = `/home?param=homedata&uid=${usid}`;
			const { data } = await serviceProvider.get(apiUrl, true, {});
			setResults(data);
		};
		search();
	}, [tourComplete]);

	return (
		<>
			<Helmet>
				<title>CPG Industry Study | SmarterChains</title>
				<meta name="description" content="CPG Industry Study" />
			</Helmet>
			<BreadcrumbsItem to="/">Home</BreadcrumbsItem>
			<BreadcrumbsItem to="/learning-center">Resource Center</BreadcrumbsItem>
			<BreadcrumbsItem to="/cpgstudy">CPG Industry Study</BreadcrumbsItem>
			<CpgstudyView homeData={results} onTourComplete={setTourComplete} {...props} />
			
		</>
	);
};
